export const COURSES = 'FETCH_COURSES';
export const EACH_COURSES = 'EACH_COURSES';
export const COURSES_INSTRUCTOR = 'FETCH_INSTRUCTOR_COURSES';
export const COURSES_VIEW = 'FETCH_COURSES_VIEW';
export const COURSES_ERROR = 'FETCH_COURSES_ERROR';
// export const COURSES_ENROLLED = 'ENROLLED';
export const ENROLLED_LIST = 'COURSES_ENROLLED_LIST';
export const NEW_COURSE_ENROLL = 'NEW_COURSE_ENROLL';
export const UPDATE_COURSES = 'UPDATE_COURSES';
export const DELETE_INSTRUCTOR_COURSE = 'DELETE_INSTRUCTOR_COURSE';
export const DEFAULT = 'DEFAULT';
export const CHECK_PROGRESS = 'CHECK_PROGRESS';
export const COURSES_PUSH = 'COURSES_PUSH';
export const COURSES_ENROLLED_LIST = 'COURSES_ENROLLED_LIST';
export const COURSES_PENDING_LIST = 'COURSES_PENDING_LIST';
export const COURSES_SEARCH = 'COURSES_SEARCH';
export const COURSES_NOT_FOUND = 'COURSES_NOT_FOUND';
export const COURSES_SEARCH_LOAD = 'COURSES_SEARCH_LOAD';
export const ENROLLMENT_STATUS = 'ENROLLMENT_STATUS';
export const FETCH_MODULE = 'FETCH_MODULE';
export const FETCH_UNIT = 'FETCH_UNIT';
export const FETCH_GRADES = 'FETCH_GRADES';
export const FETCH_ASSIGNMENT_GRADES = 'FETCH_ASSIGNMENT_GRADES';
export const FETCH_ASSIGNMENT_GRADES_SUCCESS = 'FETCH_ASSIGNMENT_GRADES_SUCCESS';
export const FETCH_ASSIGNMENT_GRADES_FAILURE = 'FETCH_ASSIGNMENT_GRADES_FAILURE';
export const UPDATE_CHAPTER = 'UPDATE_CHAPTER';
export const FETCH_PROGRAM = 'FETCH_PROGRAM';
export const FETCH_OTHER_PROGRAM = 'FETCH_OTHER_PROGRAM';
export const FETCH_PROGRAM_COURSES = 'FETCH_PROGRAM_COURSES';
export const FETCH_PROGRAM_LIST = 'FETCH_PROGRAM_LIST';
